<!--Titre du right-pane - au complet () - plus bouton ajouter-->
<div class="main-page-toolbar">
  <h1 class="page-titre"><mat-icon>{{IconGlobalPage}}</mat-icon>{{TitreGlobalPage}}</h1>
</div>

<div class="main-page-container">
  <div class="listpage-container">
    <div class="listpage-header">
      <!-- CHAMPS RECHERCHE -->
      <div class="listpage-search-container">
        <mat-form-field appearance="outline">
          <mat-label>ID en-tête</mat-label>
          <input matInput [(ngModel)]="recherche.ItemReceptionHeaderId" name="ItemReceptionHeaderId" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>#Produit</mat-label>
          <input matInput [(ngModel)]="recherche.ProductNumber" name="ProductNumber" />
        </mat-form-field>

        <mat-checkbox color="primary" [(ngModel)]="recherche.LigneErreurReceptionERP" name="LigneErreurReceptionERP">Limiter sur erreur</mat-checkbox>
      </div>

      <div class="recherche-btn-container">
        <button type="button" mat-stroked-button color="primary" (click)="effacerRecherche()"><mat-icon>delete</mat-icon> Effacer</button>
        <button type="button" mat-flat-button color="primary" (click)="rechercher()"><mat-icon>search</mat-icon> Rechercher</button>
        <a mat-flat-button color="accent" style="cursor: pointer; align-self: baseline" (click)="exportexcel()"> <mat-icon>upload_file</mat-icon>Excel </a>
        <span class="pagination-count">{{ count ? count + " élément(s) trouvé(s)" : " " }}</span>
      </div>
    </div>
    <div class="listpage-body">
      <button type="button" mat-flat-button color="warn" (click)="RelancerReceptionLigneNonRecue()"><mat-icon>delete</mat-icon>Relancer réception</button>

      <!-- LISTE -->

      <table
        id="myMainTable"
        class="table-liste table-liste-clickable"
        mat-table
        #table
        [dataSource]="dataSource"
        matSort
        matSortStart="desc"
        (matSortChange)="sortData($event)"
      >
        <ng-container matColumnDef="{{ champ['key'] }}" *ngFor="let champ of champs">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [class.align-right]="champ['type'] == 'number' || champ['type'] == 'currency'"
            [class.align-center]="champ['type'] == 'boolean'"
          >
            {{ champ["nom"] }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            [class.align-right]="champ['type'] == 'number' || champ['type'] == 'currency'"
            [class.align-center]="champ['type'] == 'boolean'"
          >
            <span *ngIf="champ['type'] == 'string' || champ['type'] == 'number'">{{ row[champ["key"]] }}</span>
            <span *ngIf="champ['type'] == 'currency'">{{ row[champ["key"]] | currency }}</span>
            <span *ngIf="champ['type'] == 'date'">{{ row[champ["key"]] | formatDate: "D" }}</span>
            <span *ngIf="champ['type'] == 'boolean' && row[champ['key']] == true">
              <mat-icon>check</mat-icon>
            </span>
          </td>
        </ng-container>

        <!-- colonnes hardcodées -->
        <ng-container matColumnDef="ForageDetail">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td mat-cell *matCellDef="let row">
            <a mat-stroked-button color="primary" [routerLink]="['/', 'reception-trace', { ItemReceptionDetailId: row.id }]">
              <mat-icon>description</mat-icon>Traces
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="champsDisplay; sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: champsDisplay" (click)="clickRow(row.id)" [class.row-highlight]="currentId == row.id"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="99">Aucun élément trouvé</td>
        </tr>
      </table>
    </div>
    <div class="listpage-footer">
      <div class="pagination-container" *ngIf="count != 0">
        Items par page:
        <mat-select
          appearance="inline"
          class="pagination-select"
          [(ngModel)]="rowPerPage"
          style="font-size: 8; width: 5em; padding-left: 10px"
          (selectionChange)="changeRowPerPage($event)"
        >
          <mat-option *ngFor="let count of rowPerPageSelect" [value]="count">{{ count }}</mat-option>
        </mat-select>
        <button mat-icon-button [disabled]="currentPage == 0" (click)="pagination('debut')">
          <mat-icon>first_page</mat-icon>
        </button>
        <button mat-icon-button [disabled]="currentPage == 0" (click)="pagination('precedent')">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <div class="pagination-pages">{{ from }} à {{ to }} de {{ count }}</div>
        <button mat-icon-button [disabled]="to > count || count == 0" (click)="pagination('suivant')">
          <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button [disabled]="to > count || count == 0" (click)="pagination('fin')">
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <!--fin listpage-container -->

  <!--Mettre l'entité de FORM ici...-->
</div>
